import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "formContainer" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center mt-3 mb-5" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "/docs/certificazioni.pdf",
    target: "_blank",
    class: "me-2"
  }, "ITA"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "/docs/certifications.pdf",
    target: "_blank"
  }, "ENG")
], -1)
const _hoisted_5 = { class: "col-4" }
const _hoisted_6 = { class: "d-flex align-items-center mt-3 mb-5" }
const _hoisted_7 = {
  href: "/docs/countryRisks.xlsx",
  target: "_blank"
}
const _hoisted_8 = { class: "mb-5" }
const _hoisted_9 = { class: "fw_700 mb-0 me-2" }
const _hoisted_10 = { class: "table table-striped w-100" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = ["href"]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "d-flex justify-content-end" }
const _hoisted_22 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_localized_text, {
          localizedKey: "Certification detail",
          text: "Certification detail",
          type: "h4",
          class: "fw_700 mb-0 me-2"
        }),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_localized_text, {
          localizedKey: "Country risk",
          text: "Country risk",
          type: "h4",
          class: "fw_700 mb-0 me-2"
        }),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("a", _hoisted_7, [
            _createVNode(_component_localized_text, {
              localizedKey: "Discover more",
              text: "Discover more"
            })
          ])
        ])
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.certificationPageVM, (docGroup, index) => {
      return (_openBlock(), _createElementBlock("div", _hoisted_8, [
        _createElementVNode("div", {
          class: _normalizeClass(["d-flex align-items-center mb-4", docGroup.isMultiple ? 'justify-content-between' : ''])
        }, [
          _createElementVNode("h4", _hoisted_9, _toDisplayString(docGroup.scoringTableCategoryTitle), 1),
          (!docGroup.isMultiple)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "scoringLabel",
                style: _normalizeStyle('background-color:' + docGroup.scoringRis.key)
              }, _toDisplayString(docGroup.scoringRis.value), 5))
            : (_openBlock(), _createBlock(_component_localized_text, {
                key: 1,
                type: "strong",
                localizedKey: "See details",
                text: "See details",
                class: "text-decoration-underline pointer",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openProductScoringDetailModal()))
              }))
        ], 2),
        _createElementVNode("table", _hoisted_10, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Certification",
                  text: "Certification",
                  type: "strong"
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Expiration Date",
                  text: "Expiration Date",
                  type: "strong"
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Attachment",
                  text: "Attachment",
                  type: "strong"
                })
              ]),
              (docGroup.isMultiple)
                ? (_openBlock(), _createElementBlock("td", _hoisted_11, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Model Name",
                      text: "Model Name",
                      type: "strong"
                    })
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.isReadOnly)
                ? (_openBlock(), _createElementBlock("td", _hoisted_12))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(docGroup.certificationSubCategories, (cert, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: cert.certificationName,
                    text: cert.certificationName
                  }, null, 8, ["localizedKey", "text"])
                ]),
                _createElementVNode("td", null, [
                  (cert.expirationDate)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$filters.date(cert.expirationDate, "DD.MM.YYYY")), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_14, "--"))
                ]),
                _createElementVNode("td", null, [
                  (cert.attachmentUrl)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: cert.attachmentUrl,
                        target: "blank"
                      }, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "View file",
                          text: "View file",
                          class: "fs_14"
                        })
                      ], 8, _hoisted_15))
                    : (_openBlock(), _createElementBlock("span", _hoisted_16, "--"))
                ]),
                (docGroup.isMultiple)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_17, [
                      (cert.productModel)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(cert.productModel), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_19, "--"))
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.isReadOnly)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        (!cert.attachmentUrl)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "btn btn-tertiary",
                              onClick: ($event: any) => (_ctx.addDocument(docGroup.isMultiple, docGroup.scoringTableCategoryTitle, cert.certificationName))
                            }, [
                              _createVNode(_component_localized_text, {
                                localizedKey: "Add doc",
                                text: "Add doc"
                              })
                            ], 8, _hoisted_22))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ])
      ]))
    }), 256))
  ]))
}